import * as Yup from 'yup';

export const FileFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    file: Yup.string().required(),
    url: Yup.string().nullable(),
  });

export const PreferenceFormSchema = () =>
  Yup.object({
    id: Yup.string().default(''),
    label: Yup.string().default(''),
  });

export type FileFormType = Yup.InferType<ReturnType<typeof FileFormSchema>>;
export type PreferenceFormType = Yup.InferType<
  ReturnType<typeof PreferenceFormSchema>
>;
